import { Box, Typography } from '@mui/material';

const steps = [
    { index: "01", title: "Você escolhe o plano", text: "Pela sua faixa de faturamento. O preço está na tela, você não precisa falar com ninguem para descobrir quanto custa." },
    { index: "02", title: "A gente abre ou migra seu CNPJ", text: "Abertura inclusa no plano. Se você já tem contador, cuidamos da troca sem voce precisar ter aquela conversa." },
    { index: "03", title: "Você volta a gravar", text: "Imposto apurado, nota emitida, obrigação entregue no prazo. Dúvida cai no grupo do WhatsApp e é respondida por gente que entende do seu mundo." },
]

const HowItWorks = () => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                px: { xs: 2, sm: 4, md: 0 },
                backgroundColor: '#F9FAFB',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
            }}
        >
            <Box
                sx={{
                    mt: { xs: 6, md: 10 },
                    mb: { xs: 6, md: 10 },
                    width: '100%',
                    maxWidth: '1100px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Cabeçalho */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: { xs: 'center', md: 'flex-start' },
                        textAlign: { xs: 'center', md: 'left' },
                    }}
                >
                    <Typography
                        component="span"
                        sx={{
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '2px',
                            color: '#1EFF86',
                            mb: 1.5,
                        }}
                    >
                        COMO FUNCIONA
                    </Typography>

                    <Typography
                        component="h1"
                        sx={{
                            fontSize: {
                                xs: '30px',
                                sm: '36px',
                                md: '39px',
                            },
                            lineHeight: 1.1,
                            fontWeight: 800,
                            letterSpacing: '-1px',
                            m: 0,
                        }}
                    >
                        Três passos. Nenhuma reunião obrigatória.
                    </Typography>
                </Box>

                {/* Passos */}
                <Box
                    sx={{
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            md: 'repeat(3, 1fr)',
                        },
                        gap: {
                            xs: 5,
                            md: 4,
                        },
                        mt: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >
                    {steps.map((passo) => (
                        <Box
                            key={passo.index}
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {/* Linha */}
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '2px',
                                    backgroundColor: '#1EFF86',
                                    mb: 2,
                                }}
                            />

                            {/* Número */}
                            <Typography
                                component="span"
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#1EFF86',
                                    mb: 1,
                                }}
                            >
                                {passo.index}
                            </Typography>

                            {/* Título */}
                            <Typography
                                component="h3"
                                sx={{
                                    fontSize: '20px',
                                    fontWeight: 700,
                                    m: 0,
                                }}
                            >
                                {passo.title}
                            </Typography>

                            {/* Texto */}
                            <Typography
                                component="p"
                                sx={{
                                    fontSize: '15px',
                                    lineHeight: 1.6,
                                    color: 'text.secondary',
                                    mt: 1.5,
                                    mb: 0,
                                    maxWidth: '300px',
                                }}
                            >
                                {passo.text}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default HowItWorks;